export default __webpack_public_path__ + "re_project-800-baf1de1b9cb906f7b66254dac8e199fc.webp";